import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type HotelSettingsAutopilotRoute from 'lumen/routes/hotel/settings/autopilot';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsAutopilotController extends Controller {
  declare model: ModelFrom<HotelSettingsAutopilotRoute>;

  // More naive change detection. Default is false, and is set to true when the user changes any setting.
  @tracked hasUserChangedAutopilotSettingsValue = false;

  @action updateHasUserChangedAutopilotSettingsValue(
    hasUserChangedAutopilotSettingsValue: boolean,
  ): void {
    this.hasUserChangedAutopilotSettingsValue =
      hasUserChangedAutopilotSettingsValue;
  }
}
